<template>
    <div>
        <div :class="{ 'section--overflow': overflow  }">
            <div :style="{ background }"
                 v-if="!bottom">
                <div v-if="fill" class="triangle" :style="style"></div>
            </div>
            <section :style="{ backgroundColor: fill }"><slot/></section>
            <div :style="{ background }"
                  v-if="bottom">
                <div v-if="fill" class="triangle" :style="style"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'new-section',
    props: {
        fill: String,
        inverted: {
            type: Boolean,
            default: false,
        },
        bottom: {
            type: Boolean,
            default: false,
        },
        overflow: {
            type: Boolean,
            default: false,
        },
        background: {
            type: String,
            default: 'transparent',
        }
    },
    computed: {
        style() {
            const deg = this.inverted ? '180deg' : '0'
            return {
                borderColor: `transparent transparent transparent ${this.fill}`,
                transform: `rotateY(${deg})`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.triangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 28.5rem 0 0 100vw;
    @media(max-width: $max-sm) {
        border-width: 5.7rem 0 0 100vw;
    }
}
.section--overflow {
    overflow: hidden;
}
</style>
